import { render } from "./component-name.vue?vue&type=template&id=126704df"
import script from "./component-name.vue?vue&type=script&setup=true&lang=js"
export * from "./component-name.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "126704df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('126704df', __exports__)) {
    api.reload('126704df', __exports__)
  }
  
  module.hot.accept("./component-name.vue?vue&type=template&id=126704df", () => {
    api.rerender('126704df', render)
  })

}


export default __exports__